import React from 'react';
import WebcamCapture from './WebcamCapture';

function App() {
  return <WebcamCapture />;
}

export default App;



// import React from 'react';
// import WebcamCapture from './WebcamCapture';
// import './App.css';

// function App() {
//   return (
//     <div className="App">
//       <WebcamCapture />
//     </div>
//   );
// }

// export default App;